// Copyright ©️ 2026 eVolve MEP, LLC

import { Input } from '@mantine/core';

import { TextWithTruncate } from 'components/Mantine/TextWithTruncate';
import { isNotNil } from 'helpers/isNotNil';

type Props = {
  /** Display text of the current selection; `null` renders the `placeholder` instead. */
  selectedLabel: string | null;
  placeholder: string | undefined;
  /** Take the font size from the surrounding element rather than `Text`'s own default. */
  inherit?: boolean;
};

/** The text a select shows in place of an input value: the selected option's label, or a placeholder. */
export const SelectValue = ({ selectedLabel, placeholder, inherit }: Props) =>
  isNotNil(selectedLabel) ? (
    <TextWithTruncate inherit={inherit}>{selectedLabel}</TextWithTruncate>
  ) : (
    <Input.Placeholder>{placeholder}</Input.Placeholder>
  );
